import { mapValues } from 'lodash'
import coerce from './coerce'

// Parse filters (if they exist)
function parseSearchQueryObject(queryObject) {
  return mapValues(queryObject, coerce)
}

export default parseSearchQueryObject
